export default __webpack_public_path__ + "static/media/Image1.88851443.png";